const rel = '';

export { rel };
